import React from "react";
import SliderHeader from "../SliderHeader/SliderHeader";

const items = [
  { type: "Background", title: "Red" },
  { type: "Skin", title: "Golden Babolex" },
  { type: "Eyes", title: "Fear Eyes" },
  { type: "Clothes", title: "African Wax" },
  { type: "Tusk", title: "None" },
  { type: "Wrist", title: "None" },
  { type: "Neck", title: "Bow Tie" },
  { type: "Glasses", title: "None" },
  { type: "Piercing", title: "Blue Piercing" },
];

const TokenDetails = () => {
  return (
    <div className="col-md-9">
      <div className="row align-items-lg-center">
        <div className="col-md">
          <h3 className="title-primary">NFT Artwork Name</h3>
          <ul className="list-unstyled d-flex w-100 align-items-center justify-content-between flex-wrap">
            <li className="secondary-text brand-Primary-2 d-flex flex-nowrap mb-3">
              <span className="svg-icon mr-2">
                <svg
                  width="22"
                  height="18"
                  viewBox="0 0 22 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.4681 0H3.53468C3.14607 0 2.82774 0.314194 2.82774 0.706936V1.41387H2.12081C1.7322 1.41387 1.41387 1.72807 1.41387 2.12081V2.82774H0.706936C0.318328 2.82774 0 3.14194 0 3.53468V17.2931C0 17.6817 0.314194 18 0.706936 18H17.6403C18.0289 18 18.3473 17.6858 18.3473 17.2931V16.5861H19.0542C19.4428 16.5861 19.7611 16.2719 19.7611 15.8792V15.1723H20.4681C20.8567 15.1723 21.175 14.8581 21.175 14.4653V0.706936C21.175 0.314194 20.8608 0 20.4681 0ZM17.6445 11.4102L15.7965 9.29352C15.6559 9.13229 15.4079 9.13229 15.2632 9.29352L13.0308 11.8484L6.94534 6.44097C6.81305 6.32108 6.61047 6.32108 6.47818 6.44097L0.715204 11.5632V3.88195C0.715204 3.68764 0.872301 3.53055 1.06661 3.53055H17.2931C17.4874 3.53055 17.6445 3.68764 17.6445 3.88195V11.4102ZM18.7069 15.8751H18.3555V3.52641C18.3555 3.1378 18.0413 2.81948 17.6486 2.81948H2.12494V2.46808C2.12494 2.27377 2.28204 2.11667 2.47634 2.11667H18.7028C18.8971 2.11667 19.0542 2.27377 19.0542 2.46808L19.0583 15.5237C19.0583 15.718 18.9012 15.8751 18.7069 15.8751ZM20.1167 14.4612H19.7653V2.11667C19.7653 1.72807 19.4511 1.40974 19.0583 1.40974H3.53468V1.05834C3.53468 0.864033 3.69178 0.706936 3.88608 0.706936H20.1125C20.3068 0.706936 20.4639 0.864033 20.4639 1.05834V14.1098H20.4681C20.4681 14.3041 20.311 14.4612 20.1167 14.4612Z"
                    fill="black"
                  />
                  <path
                    d="M12.7086 5.64307C11.9314 5.64307 11.2988 6.27559 11.2988 7.0528C11.2988 7.83002 11.9314 8.46254 12.7086 8.46254C13.4858 8.46254 14.1183 7.83002 14.1183 7.0528C14.1183 6.27559 13.4858 5.64307 12.7086 5.64307Z"
                    fill="black"
                  />
                </svg>
              </span>
              Collection name
            </li>
            <li className="secondary-text brand-Primary-2 d-flex flex-nowrap mb-3">
              <span className="svg-icon mr-2">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="18" height="18" fill="url(#pattern0)" />
                  <defs>
                    <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use transform="scale(0.00195312)" />
                    </pattern>
                    <image id="image0_385_918" width="512" height="512" />
                  </defs>
                </svg>
                0x9da0c4...45bc51
              </span>
            </li>
            <li className="secondary-text brand-Primary-2 d-flex flex-nowrap mb-3">
              <span className="svg-icon mr-2">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="18" height="18" fill="url(#pattern1)" />
                  <defs>
                    <pattern
                      id="pattern1"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use transform="scale(0.00195312)" />
                    </pattern>
                    <image id="image0_385_862" width="512" height="512" />
                  </defs>
                </svg>
              </span>
              May 1, 2021 (Ethereum)
            </li>
            <li className="secondary-text brand-Primary-2 d-flex flex-nowrap mb-3">
              <span className="svg-icon mr-2">
                <svg
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.89 6.45H5.02L4.56 9.02H6.43L6.89 6.45ZM11.41 4.49L11.2 5.63C11.1467 5.91 11.03 6.11667 10.85 6.25C10.67 6.38333 10.3833 6.45 9.99 6.45H9.16L8.7 9.02H9.96C10.24 9.02 10.4367 9.10333 10.55 9.27C10.67 9.43667 10.7 9.72 10.64 10.12L10.5 10.98H8.42L7.68 15H6.41C6.28333 15 6.16333 14.97 6.05 14.91C5.94333 14.85 5.85 14.77 5.77 14.67C5.69667 14.5633 5.64333 14.4433 5.61 14.31C5.58333 14.1767 5.58667 14.0333 5.62 13.88L6.15 10.98H4.29L3.75 14.02C3.68333 14.3733 3.53333 14.6267 3.3 14.78C3.06667 14.9267 2.80333 15 2.51 15H1.29L2.02 10.98H0.99C0.71 10.98 0.51 10.9 0.39 10.74C0.276667 10.5733 0.25 10.29 0.31 9.89L0.45 9.02H2.3L2.76 6.45H0.69L0.9 5.31C0.953333 5.03 1.07 4.82333 1.25 4.69C1.43667 4.55667 1.72667 4.49 2.12 4.49H3.03L3.61 1.4C3.66333 1.12 3.79667 0.899999 4.01 0.739999C4.23 0.573332 4.48333 0.489999 4.77 0.489999H6.03L5.29 4.49H7.16L7.9 0.489999H9.13C9.41667 0.489999 9.64333 0.579999 9.81 0.76C9.98333 0.933332 10.0467 1.15333 10 1.42L9.43 4.49H11.41Z"
                    fill="black"
                  />
                </svg>
              </span>
              58rZU...6gNnQum2
            </li>
          </ul>
          <p className="secondary-text brand-gray">
            <strong>Description: </strong>6000 unique Babolex, algorithmically
            generated. The First NFT collection of Vincent FAUDEMER. ..
          </p>
        </div>
        <div className="col-auto mt-3 mt-md-0">
          <a
            className="btn-primary"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Watchlist
          </a>
          <a
            className="btn-primary ml-sm-3"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            Trade NFT
          </a>
        </div>
      </div>
      <div className="col-12 px-0">
        <div className="bg-white tab-content-slide radius-xl px-5 py-5 py-md-5 mt-4 break">
          <SliderHeader items={items} />
        </div>
      </div>
    </div>
  );
};

export default TokenDetails;
